<script>
import axios from 'axios'

export default {
  methods: {
    gravarLogImportacaoCandidatosOutrasFases() {
      const body = {
        idPublicacao: this.controlePage.idpublicacao,
        idOutraFase: this.idoutfase,
        tpImportacaoOutrasFases: this.tpImportacao,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario
      }

      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/GravarLogImportacaoCandidatosOutrasFases',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listarLogs()
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>